import './style/stats-table.css';
const StatsTable = () => {
    return (
        <div>

        </div>
    )
}
export default StatsTable;